import { render, staticRenderFns } from "./ReiTabbar.vue?vue&type=template&id=3aa73bb1&scoped=true&"
import script from "./ReiTabbar.vue?vue&type=script&lang=js&"
export * from "./ReiTabbar.vue?vue&type=script&lang=js&"
import style0 from "./ReiTabbar.vue?vue&type=style&index=0&id=3aa73bb1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa73bb1",
  null
  
)

export default component.exports